import React, { useState } from 'react'
import { Link as ReactLink } from 'react-router-dom'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { Flex, Image, Card, Box, Button, useMatchBreakpoints, Text } from 'vvs-uikit'
import PageSection from 'components/PageSection'
import { useWeb3React } from '@web3-react/core'
import useTheme from 'hooks/useTheme'
import Container from 'components/Layout/Container'
import { SEOHead } from 'components/Layout/Page'
import { isAfter, intervalToDuration } from 'date-fns'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

import Hero, { DotScaleContainer } from './components/Hero'
import MetricsSection from './components/MetricsSection'
import Community from './components/Community'
import FeaturesGuide from './components/FeaturesGuide'
import VvsTokenIntro from './components/VvsTokenIntro'
import UserBanner from './components/UserBanner'
import TopBlingFarmAndCrystalPool from './components/TopBlingFarmAndCrystalPool'
import { useLocalStorage } from './utils'

dayjs.extend(duration)

const StyledHeroSection = styled(PageSection)`
  padding-top: 10px;
  height: 1024px;

  ${({ theme }) => theme.mediaQueries.sm} {
    height: 890px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    height: 740px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    height: 830px;
  }
`

const UserBannerWrapper = styled(Container)`
  position: relative;
  z-index: 10;
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  margin: -100px auto 0;

  ${({ theme }) => theme.mediaQueries.md} {
    position: absolute;
  }

  // ${({ theme }) => theme.mediaQueries.lg} {
  //   padding-left: 24px;
  //   padding-right: 24px;
  // }
`

const FeaturesGuideWrapper = styled(PageSection)`
  padding-bottom: 48px;
  ${({ theme }) => theme.mediaQueries.md} {
    padding-bottom: 88px;
  }
`
const CommunityWrapper = styled(PageSection)`
  height: 540px;
  ${({ theme }) => theme.mediaQueries.md} {
    height: 650px;
  }
`

// IGO Promotional Banner
const StyledCard = styled(Box)`
  border-radius: ${({ theme }) => theme.radii.card};
  width: 100%;
  height: 120px;
  padding: 0px;
  height: fit-content;
  max-width: 1200px;
  margin-left: 0px;
`

const BannerImage = styled(Image)`
  margin-bottom: 0px;
  @media screen and (max-width: 768px) {
    width: 350px;
    height: 120px;
  }
`

const IGOText = styled(Text)`
  font-size: 28px;
  @media screen and (max-width: 1110px) {
    font-size: 20px;
  }
`

const IGOMobileText = styled(Text)`
  font-size: 20px;
  @media screen and (max-width: 750px) {
    font-size: 14px;
  }
  @media screen and (max-width: 320px) {
    font-size: 15px;
  }
`

const IGODate = styled(Text)`
  font-size: 35px;
  @media screen and (max-width: 1110px) {
    font-size: 26px;
  }
  @media screen and (max-width: 972px) {
    font-size: 20px;
  }
`

const IGODateMobile = styled(Text)`
  font-size: 36px;
  @media screen and (max-width: 576px) {
    font-size: 28px;
  }
  @media screen and (max-width: 320px) {
    font-size: 24px;
  }
`

const TextFlex = styled(Flex)`
  width: 100%;
  @media screen and (max-width: 576px) {
    width: 400px;
  }
  @media screen and (max-width: 576px) {
    width: 400px;
  }
  @media screen and (max-width: 445px) {
    width: 350px;
  }
  @media screen and (max-width: 400px) {
    width: 300px;
  }
  @media screen and (max-width: 320px) {
    width: 250px;
  }
`

const Bar = styled.div`
  width: 5px;
  height: 40px;
  background-color: gray;
  margin: 0 20px;
`

export const IGOPromotionalBanner = ({ onClick }) => {
  const { isDark, theme } = useTheme()
  const { isMobile, isTablet, isDesktop } = useMatchBreakpoints()
  return (
    <StyledCard
      background="white"
      style={{
        marginTop: '10px',
        marginBottom: '20px',
        padding: isMobile ? '20px' : '0px',
        marginLeft: '30px',
        marginRight: isDesktop ? '0px' : '30px',
      }}
    >
      {isDesktop ? (
        <Flex flexDirection="row" alignItems="center" pl="40px" justifyContent="space-between" height="100%">
          <Button as={ReactLink} to="/igo" height={60} width={200} marginRight={isDesktop || isTablet ? '20px' : '0px'}>
            Learn More
          </Button>
          <Flex flexDirection="row" alignItems="center" width="100%" height="100%">
            <IGOText fontWeight={1000} bold color={theme.colors.darkBlue}>
              Initial Gem Offerings
            </IGOText>
            <Image height={40} width={111} ml={10} src="/images/igo/singleFinanceLogo.png" alt="Single Finance Logo" />
            <Bar />
            <IGODate bold fontWeight={1000} color="#ffbf00">
              18 - 19 Jan 2022
            </IGODate>
          </Flex>
          <Image
            height={98}
            width={124}
            src="/images/igo/igoBanner.png"
            alt="IGO banner"
            style={{ marginRight: '20px' }}
          />
          <Box height="100%" width="20px" onClick={() => onClick()} marginRight="10px">
            <BannerImage height={20} width={20} src="/images/userBanner/close.png" alt="close" />
          </Box>
        </Flex>
      ) : isTablet ? (
        <Flex flexDirection="row" alignItems="center" pl="40px" justifyContent="space-between" height="100%">
          <Button as={ReactLink} to="/igo" height={60} width={250} marginRight={isDesktop || isTablet ? '20px' : '0px'}>
            Learn More
          </Button>
          <Flex flexDirection="column" justifyContent="center" width="100%" height="100%">
            <Flex>
              <IGOMobileText fontWeight={1000} bold color={theme.colors.darkBlue} style={{ alignSelf: 'center' }}>
                Initial Gem Offerings
              </IGOMobileText>
              <Image
                height={40}
                width={111}
                ml={10}
                src="/images/igo/singleFinanceLogo.png"
                alt="Single Finance Logo"
              />
            </Flex>
            <IGODate bold fontWeight={1000} color="#ffbf00">
              18 - 19 Jan 2022
            </IGODate>
          </Flex>
          <Image
            height={98}
            width={124}
            src="/images/igo/igoBanner.png"
            alt="IGO banner"
            style={{ marginRight: '20px' }}
          />
          <Box height="100%" width="20px" onClick={() => onClick()} marginRight="10px">
            <BannerImage height={20} width={20} src="/images/userBanner/close.png" alt="close" />
          </Box>
        </Flex>
      ) : (
        <Flex flexDirection="column" alignItems="start" justifyContent="space-between">
          <Flex flexDirection="column" alignItems="start">
            <Flex flexDirection="row" alignItems="center" height="100%" justifyContent="space-evenly">
              <TextFlex flexDirection="row" alignItems="center" height="100%" justifyContent="start">
                <IGOText fontWeight={1000} bold color={theme.colors.darkBlue}>
                  Initial Gem Offerings
                </IGOText>
              </TextFlex>
              <Box height="100%" onClick={() => onClick()}>
                <BannerImage height={20} width={20} src="/images/userBanner/close.png" alt="close" />
              </Box>
            </Flex>
            <IGODateMobile width="100%" bold fontWeight={1000} color="#ffbf00">
              18 - 19 Jan 2022
            </IGODateMobile>
          </Flex>
          <Flex flexDirection="row" alignItems="center" height="100%" justifyContent="space-between" width="100%">
            <Button
              as={ReactLink}
              to="/igo"
              height={60}
              width={160}
              marginTop={20}
              marginRight={isDesktop || isTablet ? '20px' : '0px'}
            >
              Learn More
            </Button>
            <Image
              height={40}
              width={111}
              style={{
                alignSelf: 'center',
                marginBottom: '-20px',
              }}
              src="/images/igo/singleFinanceLogo.png"
              alt="Single Finance Logo"
            />
          </Flex>
        </Flex>
      )}
    </StyledCard>
  )
}

const Home: React.FC = () => {
  const { theme } = useTheme()
  const { account } = useWeb3React()
  const { isDesktop } = useMatchBreakpoints()
  const HomeSectionContainerStyles = { margin: '0', width: '100%', maxWidth: '1300px' }
  // IGO promo banner parameters
  const [isBannerClose, setIsBannerClose] = useLocalStorage('isIGOBannerClose', false)
  const endDate = '2022-01-21T12:00:00+00:00' // FIXME: Update for new IGO
  const start = new Date()
  const end = new Date(endDate)
  const isExpired = isAfter(start, end)

  return (
    <>
      <SEOHead />
      {!isExpired && !isBannerClose ? (
        <Flex width="100%" justifyContent="center" alignItems="center" background={theme.colors.secondary}>
          <IGOPromotionalBanner onClick={() => setIsBannerClose(!isBannerClose)} />
        </Flex>
      ) : null}
      <StyledHeroSection
        innerProps={{
          style: {
            margin: '0',
            width: '100%',
          },
        }}
        background={
          theme.isDark
            ? 'radial-gradient(103.12% 50% at 50% 50%, #21193A 0%, #191326 100%)'
            : 'linear-gradient(139.73deg, #E6FDFF 0%, #F3EFFF 100%)'
        }
        index={2}
        hasCurvedDivider={false}
        style={{ paddingTop: 70 }}
      >
        {account && (
          <UserBannerWrapper>
            <UserBanner />
          </UserBannerWrapper>
        )}
        <Hero />
      </StyledHeroSection>
      <PageSection
        innerProps={{
          style: {
            margin: '0',
            width: '100%',
            justifyContent: 'center',
          },
        }}
        background={theme.colors.backgroundAlt}
        index={2}
        hasCurvedDivider={false}
        justifyContent="center"
      >
        <MetricsSection />
      </PageSection>
      <FeaturesGuideWrapper
        innerProps={{ style: HomeSectionContainerStyles }}
        background={theme.colors.secondary}
        index={2}
        hasCurvedDivider={false}
      >
        <FeaturesGuide />
      </FeaturesGuideWrapper>
      <TopBlingFarmAndCrystalPool />
      <PageSection
        innerProps={{ style: HomeSectionContainerStyles }}
        background={theme.colors.backgroundAlt}
        index={2}
        hasCurvedDivider={false}
      >
        <VvsTokenIntro />
      </PageSection>
      <CommunityWrapper
        innerProps={{ style: HomeSectionContainerStyles }}
        background={theme.colors.secondary}
        index={2}
        hasCurvedDivider={false}
      >
        <Community />
      </CommunityWrapper>
    </>
  )
}

export default Home
